import React from 'react';
import classNames from 'classnames';

import './Button.scss';

export interface ButtonProps {
  children: string | React.ReactNode;
  href?: string;
  type: 'Primary' | 'Secondary';
  onClick?(): void;
};

export const Button = ({
  children,
  href,
  type = 'Primary',
  onClick
  }: ButtonProps) => {
  return <a
    onClick={onClick}
    styleName={classNames({
        btn: true,
        'btn--yellow': type === 'Primary',
        'btn--test-red': type === 'Secondary'
    }
      )}
    href={href}
  >
    {children}
  </a>;
};

export default Button;
